module.exports = __webpack_public_path__ + "media/images/partners/cyber-first-d191937f46aeb9eff087fc309549c379.svg";